export default "__VITE_ASSET__3bb22ca3__"